import { styled } from '@mui/material';

import { Typography, CenteredLoader, DeferredImage } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

export type PagePreviewProps = {
  base64Image: string | null;
  isLoading: boolean;
};

const PagePreviewContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background: 'var(--background-background-secondary-color)',
  border: '1px solid var(--stroke-stroke-primary-color)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.spacing(45),
  position: 'relative',
  overflow: 'hidden',
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
}));

const LoadingOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  background: 'var(--background-background-secondary-color)',
  opacity: 0.5,
}));

const Placeholder = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

const PlaceholderTitle = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
  color: 'var(--text-text-primary-color)',
});

export const PagePreview = ({ base64Image, isLoading }: PagePreviewProps) => {
  const { t } = useI18n();

  return (
    <PagePreviewContainer>
      {isLoading ? (
        <LoadingOverlay>
          <CenteredLoader />
        </LoadingOverlay>
      ) : null}
      {base64Image ? (
        <DeferredImage src={base64Image} alt="Design" />
      ) : (
        <Placeholder>
          <PlaceholderTitle>
            {t('appraisals:select_design_from_canvas')}
          </PlaceholderTitle>
        </Placeholder>
      )}
    </PagePreviewContainer>
  );
};
